<template>
  <div class="company-register-page">
    <a-card class="company-register-card">
      <div class="company-register-title">{{ $t('creatingNewBusiness') }}</div>
      <dol-form-model :model="editForm" :rules="validateRules" ref="editForm">
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="COMPANY_NAME">
          <template slot="label">
            {{ $t('通用_企业名称') }}
          </template>
          <a-input v-model.trim="editForm.COMPANY_NAME" size="large"/>
          <div style="line-height: 1;padding: 2px 0;">
            <a-space><a-icon type="question-circle" />{{ $t('registerNameMessage') }}</a-space>
          </div>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="COMPANY_NAME_ENG">
          <template slot="label">
            {{ $t('nameEng') }}
          </template>
          <a-input v-model.trim="editForm.COMPANY_NAME_ENG" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="COMPANY_NAME_RUS">
          <template slot="label">
            {{ $t('nameRus') }}
          </template>
          <a-input v-model.trim="editForm.COMPANY_NAME_RUS" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="PERSON">
          <template slot="label">
            {{ $t('contact') }}
          </template>
          <a-input v-model.trim="editForm.PERSON" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="MOBILE">
          <template slot="label">
            {{ $t('mobile') }}
          </template>
          <a-input size="large" v-model.trim="editForm.MOBILE" :placeholder="$t('pleaseEnterYourMobilePhoneNumber')">
            <dol-select
                slot="addonBefore"
                size="large"
                autoSelect
                v-model.trim="editForm.MOBILE_PREFIX"
                source="server"
                server-type="DotNet"
                :dot-net-table-type="3"
                :dot-net-columns="false"
                dotNetReturnListField="DATA_LIST"
                :dot-net-table-name="`SELECT BS.CODE_ID,BS.CODE_CODE,BS.CODE_NAME,BS.TYPE_ID,BST.TYPE_CODE,BST.TYPE_NAME,
                BST.IS_VISIBLE AS TYPE_IS_VISIBLE
                FROM BM_BASE_CODE BS, BM_BASE_CODE_TYPE BST
                WHERE BS.TYPE_ID = BST.TYPE_ID
                AND BST.TYPE_CODE='2009'`"
                label-field="CODE_NAME"
                key-field="CODE_NAME"
                value-field="CODE_NAME"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="ADDRESS">
          <template slot="label">
            {{ $t('businessAddressDetails') }}
          </template>
          <a-input v-model.trim="editForm.ADDRESS" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="EMAIL">
          <template slot="label">
            {{ $t('email') }}
          </template>
          <a-input v-model.trim="editForm.EMAIL" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="GUID_CODES">
          <template slot="label">
            {{ $t('businessLicense') }}
          </template>
          <div>
            <dol-upload @finished="finished" :paramsData="paramsData"
                        :placeholder="$t('uploadBusinesslicense')" serverType="2009"
                        v-model.trim="editForm.GUID_CODE"></dol-upload>
<!--            <dol-upload-img :placeholder="$t('uploadBusinesslicense')" @finished="finished" :paramsData="paramsData" serverType="2009" v-model.trim="editForm.GUID_CODES"></dol-upload-img>-->
            <div class="company-register-form-item_message">
              {{ $t('warmPrompt') }}：<br>{{ $t('warmPromptContent') }}
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item class="company-register-form-item company-register-form-button" label=" " :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}">
          <a-button @click="companyRegister" size="large" style="background-color: #1F6CBA;color: #FFFFFF" block>{{ $t('authenticationSubmit') }}</a-button>
<!--          <a-checkbox v-model.trim="flag">{{ $t('loginAgreementTitle') }}</a-checkbox>-->
        </a-form-model-item>
      </dol-form-model>
    </a-card>
  </div>
</template>

<script>
import loginHeader from "../../components/common/login-header";
export default {
  name: "companyRegister",
  components:{loginHeader},
  data(){
    return{
      editForm: {
        COMPANY_NAME: '',
        PERSON: '',
        MOBILE: '',
        ADDRESS: '',
        EMAIL: '',
        GUID_CODES: {}
      },
      validateRules: {
        COMPANY_NAME: [{ required: true, message: this.$t('pleaseFillInTheEnterpriseName'), trigger: ['blur','change']},{
          validator: (rule, value, callback) => {
            if (value.indexOf('\'') >= 0 || value.indexOf('"') >= 0) {
              callback(this.$t('contentCheck'))
            } else {
              callback()
            }
          }
        }],
        COMPANY_NAME_ENG: [{ required: true, message: this.$t('pleaseFillInTheEnterpriseName'), trigger: ['blur','change']}, {
          validator: (rule, value, callback) => {
            if (value.indexOf('\'') >= 0 || value.indexOf('"') >= 0) {
              callback(this.$t('contentCheck'))
            } else {
              callback()
            }
          }
        }],
        COMPANY_NAME_RUS: [{ required: true, message: this.$t('pleaseFillInTheEnterpriseName'), trigger: ['blur','change']},{
          validator: (rule, value, callback) => {
            if (value.indexOf('\'') >= 0 || value.indexOf('"') >= 0) {
              callback(this.$t('contentCheck'))
            } else {
              callback()
            }
          }
          }],
        MOBILE: [{ required: true, message:this.$t('pleaseEnterMobilePhoneNumber'), trigger: ['blur','change'] }],
        PERSON: [{ required: true, message: this.$t('pleaseEnterTheContactPerson'), trigger: ['blur','change'] }],
        GUID_CODES: [{ required: true, message: this.$t('pleaseUploadYourBusinessLicense'), trigger: ['blur','change'] }],
        ADDRESS: [{ required: true, message: this.$t('pleaseFillInTheCompanyAddress'), trigger: ['blur','change'] }],
        EMAIL: [{ required: true, message: this.$t('pleaseFillInTheEmail'), trigger: ['blur','change'] }],
      },
      flag: true,
      paramsData: {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021001",
        "TARGET_TYPE": "20071001",
        "TARGET_ID":"",
        "GUID_CODE":""
      },
      userInfo: this.$store.state?.userInfo,
      labelColNum: 24,
      wrapperColNum:24
    }
  },
  watch:{
    '$i18n.locale'(){

    }
  },
  computed: {

  },
  methods:{
    finished(data){
      this.$set(this.editForm,'GUID_CODES',data?.['FILE_LIST']?.[0]);
      this.$refs.editForm.validateField('GUID_CODES');
    },
    companyRegister(){
      this.$refs.editForm.validate((val) =>{
        if(val){
          let condition = Object.assign({},this.editForm);
          condition.SYS_TYPE = '20011003';
          condition.CITY_IDS = '';
          condition.GUID_CODES = this.editForm?.GUID_CODES?.GUID_CODE ?? '';
          condition.USER_ID = this.userInfo?.USER_ID;
          delete condition.GUID_CODE
          if(!this.flag){
            this.$message.info(this.$t('pleaseConfirmAndCheckTheUserPrivacyAgreement'));
            return true;
          }
          this.$h5Api({
            type: '2005',
            data: [condition],
            showMessage: true,
          }).then(({data, total}) => {
            this.$store.commit('afterLogin', data);
            this.$router.replace({
              name: 'registerDetail',
            });
          }).catch(e =>{
            this.$message.error(this.$t(e.status));
          })
        }
      })
    }
  },
  created() {
    let data = this.$store?.state?.userInfo;
    if(data){
      this.editForm = {
        COMPANY_NAME: data.COMPANY_NAME,
        COMPANY_NAME_ENG: data.COMPANY_NAME_ENG,
        COMPANY_NAME_RUS: data.COMPANY_NAME_RUS,
        COMPANY_ID: data.COMPANY_ID,
        PERSON : data.USER_NAME || data.PERSON,
        MOBILE : data.MOBILE || data.USER_MOBILE,
        ADDRESS: data.ADDRESS,
        EMAIL: data.EMAIL || data.USER_CODE,
      }
      if(this.$store?.state?.fileList?.[0]){
        this.editForm.GUID_CODE = this.$store?.state?.fileList?.[0];
      }
    }
  }
}
</script>

<style lang="scss">
  .company-register-page{
    background-color: #F5F7F9;
    .company-register-card{
        padding: 8px 180px;
        width: 990px;
        margin: 24px auto;
        .company-register-title{
          text-align: center;
          margin-bottom: 32px;
          font-size: 24px;
          font-weight: 700;
          color: #333333;
          line-height: 33px;
        }
        .company-register-form-button{
          label::after {
            content: '';
            position: relative;
            top: -0.5px;
            margin: 0 8px 0 2px;
          }
        }
        .company-register-form-item{
          label{
            font-size: 16px;
          }

          .company-register-form-item_message{
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            letter-spacing: 1px;
          }
        }
      }
  }
</style>